import React from 'react';
import logo from '../../images/logo-white.png';
import {MDBContainer, MDBFooter} from "mdb-react-ui-kit";

const Footer = () => {
    return (
        <div className="bg-dark d-flex justify-content-between p-4 align-items-center">
            <div>
                <img width="100" src={logo} alt=""/>
            </div>
            <div>
                <MDBFooter color="white" className="font-small pt-2 mt-0">
                    <MDBContainer fluid>
                        &copy; {new Date().getFullYear()} We Learn, Inc.
                    </MDBContainer>
                </MDBFooter>
            </div>
        </div>
    );
};

export default Footer;
